import { useContext } from 'react';

import { ThemeContext } from '../state/theme';

/**
 * Reads the current theme.
 *
 * Outside a `ThemeProvider` this yields the context's own default value, the same
 * way `AppDependenciesContext` is consumed without the app ever mounting a provider.
 */
export const useTheme = () => useContext(ThemeContext);
